import {
  FunctionField,
  Loading,
  TextField,
  TextInput,
} from 'react-admin'
import { useMediaQuery } from '@mui/material'
import {
  Datagrid,
  List,
  Filter,
  NumberField,
  DateField,
  CurrencyField,
} from '../../custom'
import {
  useEarliestIncompletePeriod,
  useLabel,
} from '../../../hooks'
import PeriodQuickFilter from '../../shared/period-quick-filter'
import ImageModal from '../../shared/image-modal'

const HourlyTicketsFilter = (props) => {
  const label = useLabel(props)

  return (
    <Filter {...props}>
      <TextInput label={label('ticket_number', 'find')} source='ticket_number_start' />
    </Filter>
  )
}

const HourlyTicketsList = props => {
  const { isLoading, period } = useEarliestIncompletePeriod()
  const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'))

  if (isLoading) return <Loading />

  return (
    <List
      {...props}
      filters={<HourlyTicketsFilter />}
      filterDefaultValues={{ broker_driver_pay_rollup_period_end_date_eq: period?.end_date }}
      actions={<PeriodQuickFilter fieldName='broker_driver_pay_rollup_period_end_date' />}
    >
      {
        isSmall ?
        <Datagrid>
          <FunctionField label='ticket_image_url' render={record => (
            <ImageModal src={record.ticket_image_url} />
          )} />
          <TextField source='ticket_number' />
          <CurrencyField source='total_pay_in_dollars' />
          <DateField source='worked_at_date' />
        </Datagrid> :
        <Datagrid>
          <FunctionField label='ticket_image_url' render={record => (
            <ImageModal src={record.ticket_image_url} />
          )} />
          <TextField source='ticket_number' />
          <NumberField source='regular_time_in_hours' />
          <NumberField source='overtime_in_hours' />
          <NumberField source='doubletime_in_hours' />
          <CurrencyField source='total_pay_in_dollars' />
          <DateField source='worked_at_date' />
        </Datagrid>
      }
    </List>
  )
}

export default HourlyTicketsList
